// Dependencies
import React from 'react';
import radium from 'radium';
import {ThemeContext} from '../../../components/theme/Theme.jsx';
import LeoSelect from '../../../components/form/LeoReactSelect';

interface PricelevelProps {
    priceLevels: any[],
    selectedPriceLevelUUID?: any,
    onChange: any,
    radioLayout?: boolean,
}

const defaultProps = {
    priceLevels: [],
    radioLayout: false,
};

function Pricelevel(propsIn: PricelevelProps) {
    const props = {...defaultProps, ...propsIn};
    const context = React.useContext(ThemeContext);

    const selectedPriceLevelUUID = props.selectedPriceLevelUUID ||
        props.priceLevels[0]?.priceLevelUuid;

    if (props.priceLevels.length === 0) return null;

    if (props.radioLayout) {
        const visiblePriceLevels = props.priceLevels.filter(pl => !pl.hideOnline);

        const highlightColor = context.themeManager.value('form-element', 'highlightColor', 'bg-color-button-hightlight');
        const fontSize = context.themeManager.value('default-button', 'fontSize', 'font-size-150');

        const style = {
            list: {
                display: 'flex',
                flexDirection: 'column' as const,
                gap: '0.4em',
            },
            row: (isSelected: boolean): any => ({
                display: 'flex',
                alignItems: 'center',
                gap: '0.75em',
                padding: '0.65em 1em',
                borderRadius: '4px',
                cursor: 'pointer',
                fontFamily: 'inherit',
                fontSize,
                width: '100%',
                textAlign: 'left' as const,
                backgroundColor: 'transparent',
                color: 'inherit',
                border: isSelected ? `2px solid ${highlightColor}` : '2px solid transparent',
                ':hover': {
                    border: `2px solid ${highlightColor}`,
                },
            }),
            radio: (isSelected: boolean): any => ({
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                border: `2px solid ${isSelected ? highlightColor : 'currentColor'}`,
                backgroundColor: 'transparent',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }),
            radioDot: (isSelected: boolean): any => ({
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: isSelected ? highlightColor : 'transparent',
            }),
            label: (isSelected: boolean): any => ({
                flex: 1,
                fontWeight: isSelected ? 'bold' : 'normal',
            }),
        };

        return (
            <div style={style.list}>
                {visiblePriceLevels.map(pl => {
                    const isSelected = pl.priceLevelUuid === selectedPriceLevelUUID;
                    return (
                        <button
                            key={pl.priceLevelUuid}
                            style={style.row(isSelected)}
                            onClick={() => props.onChange({target: {value: pl.priceLevelUuid}})}
                            type="button"
                            aria-pressed={isSelected}
                        >
                            <span style={style.radio(isSelected)}>
                                <span style={style.radioDot(isSelected)}/>
                            </span>
                            <span style={style.label(isSelected)}>
                                {pl.name}{pl.forSponsors ? ' ★' : ''}
                            </span>
                            <span>
                                {parseFloat(pl.price.value).toFixed(2)} €
                            </span>
                        </button>
                    );
                })}
            </div>
        );
    }

    const selectedPriceLevel = props.priceLevels.find(pl => pl.priceLevelUuid === selectedPriceLevelUUID);
    const selectOptions = [{value: 0, label: 'Preisstufe', isSelected: false, isDisabled: true}]
    props.priceLevels.map(priceLevel => {
        if (!priceLevel.hideOnline) {
            selectOptions.push({
                value: priceLevel.priceLevelUuid,
                label: `${priceLevel.name} (${parseFloat(priceLevel.price.value).toFixed(2)} €) ${priceLevel.forSponsors ? " ★" : ""}`,
                isSelected: priceLevel.priceLevelUuid === selectedPriceLevelUUID,
                isDisabled: false
            })
        }
    })

    return (
        <div>
            <LeoSelect
                name="pricelevel"
                value={selectedPriceLevelUUID}
                id={'pl_' + selectedPriceLevelUUID}
                valueInput={`${selectedPriceLevel.name} (${parseFloat(selectedPriceLevel.price.value)
                    .toFixed(2)}€) ${selectedPriceLevel.forSponsors ? " ★" : ""}`}
                labeledById={"pl_headline"}
                onChange={props.onChange}
                placeholder="Preisstufe"
                options={selectOptions}
            >
            </LeoSelect>
        </div>
    );
}

export default radium(Pricelevel);
